import { render, staticRenderFns } from "./FollowUpPanel.vue?vue&type=template&id=c98e0cd2&scoped=true"
import script from "./FollowUpPanel.vue?vue&type=script&lang=js"
export * from "./FollowUpPanel.vue?vue&type=script&lang=js"
import style0 from "./FollowUpPanel.vue?vue&type=style&index=0&id=c98e0cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98e0cd2",
  null
  
)

export default component.exports